const updates = [
  { date: '2026-07-30', tag: '版本更新', title: 'v3.8.2版本发布，优化4K播放流畅度与字幕匹配准确率' },
  { date: '2026-07-28', tag: '片源更新', title: '暑期档院线大片专题上线，《长安三万里2》《射雕英雄传》高清资源已入库' },
  { date: '2026-07-25', tag: '功能升级', title: '投屏功能全面升级，新增对小米电视、华为智慧屏的原生适配支持' },
  { date: '2026-07-22', tag: '片源更新', title: '热门韩剧《信号2》全集高清上线，同步更新中文字幕' },
  { date: '2026-07-20', tag: '安全公告', title: '通过360、腾讯手机管家双平台安全检测认证，用户可放心下载使用' },
  { date: '2026-07-18', tag: '片源更新', title: '国产动画《深海2》4K修复版独家上线，重温视觉盛宴' },
  { date: '2026-07-15', tag: '版本更新', title: 'v3.8.1版本修复部分机型闪退问题，提升app启动速度约30%' },
  { date: '2026-07-12', tag: '专题上线', title: '王家卫电影回顾专题上线，《花样年华》《重庆森林》等经典作品高清重制' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">版本更新、片源上新、功能升级，第一时间了解91影视最新资讯</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 top-1.5"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                    item.tag === '版本更新'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '片源更新'
                      ? 'bg-accent-100 text-accent-700'
                      : item.tag === '功能升级'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-700">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}